interface BoardEmptyStateProps {
  title: string;
  description: string;
  /** 돋보기 아이콘 (게시판 목록에서만 쓴다) */
  showIcon?: boolean;
}

/** 목록이 비었을 때 안내. 게시판 목록·FAQ 공용 */
export function BoardEmptyState({
  title,
  description,
  showIcon = false,
}: BoardEmptyStateProps) {
  // 위 선은 탭 밑줄이 맡는다 — 선을 또 그으면 탭 줄이 떠 보인다
  return <div className="flex flex-col items-center justify-center py-24 text-center">
    {showIcon && (
      <div className="mb-4 grid h-16 w-16 place-items-center rounded-full bg-black/[0.04] dark:bg-white/10 text-neutral-950/30 dark:text-white/30">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M20 20L16 16"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
    )}
    <p className="text-[15px] font-semibold text-neutral-950 dark:text-neutral-100">
      {title}
    </p>
    <p className="mt-1 text-[13px] text-neutral-950/55 dark:text-white/55">
      {description}
    </p>
  </div>
}
